import { Component, OnInit } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { Router } from "@angular/router";
import { AuthService } from "@app/shared/auth.service";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-register",
  templateUrl: "./register.component.html",
  styles: [],
})
export class RegisterComponent implements OnInit {
  registerForm: FormGroup;
  slideConfig2 = {
    className: "center",
    centerMode: true,
    infinite: true,
    centerPadding: "0",
    slidesToShow: 1,
    speed: 500,
    dots: false,
  };
  loading: boolean = false;
  countries: any[] = [];

  terms: boolean = false;

  constructor(
    private router: Router,
    private authService: AuthService,
    public toasterService: ToastrService
  ) {}

  initForm() {
    this.registerForm = new FormGroup({
      emailId: new FormControl("", [
        Validators.required,
        Validators.pattern(
          /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        ),
      ]),
      phoneno: new FormControl("+91", [
        Validators.required,
        Validators.pattern(
          /^\+((?:9[679]|8[035789]|6[789]|5[90]|42|3[578]|2[1-689])|9[0-58]|8[1246]|6[0-6]|5[1-8]|4[013-9]|3[0-469]|2[70]|7|1)(?:\W*\d){6,13}\d$/
        ),
      ]),
      businessName: new FormControl("", [Validators.required]),
      contactName: new FormControl("", [Validators.required]),
      designation: new FormControl("", [Validators.required]),
      // companyCategory: new FormControl(""),
      // website: new FormControl(""),
      // registrationNumber: new FormControl(""),
      // address: new FormControl(""),
      // city: new FormControl(""),
      // state: new FormControl(""),
      // country: new FormControl(null, [Validators.required]),
      // postalCode: new FormControl("", [Validators.required]),
      
    });
  }
  ngOnInit() {
    this.initForm();
    this.authService.getRegisterDetails().subscribe(
      (res) => {
        this.countries = res.countryList.map((n) => {
          return { id: n.id, name: n.VALUE };
        });
      },
      (err) => {}
    );
  }

  displayMailSent: boolean = false;
  registerUser() {
    // console.log(this.registerForm.getRawValue());
    // this.authService.register(this.registerForm.getRawValue()).subscribe(res=>{
    //   console.log(res)
    // },err=>{
    //   console.log(err)
    // });
    if (!this.terms) {
      this.toasterService.warning(
        "please accept the terms and conditions!",
        "Warning",
        {
          positionClass: "toast-top-right",
        }
      );
      return false;
    }
    if (this.registerForm.valid) {
      let temp = this.registerForm.getRawValue();
      this.authService.register(temp).subscribe(
        (res) => {
          console.log(res);
          if (res.errors) {
            console.log("res");
            this.toasterService.error(
              res?.errors[0]?.message
                ? res?.errors[0]?.message
                : "Some error occured",
              "Error",
              {
                positionClass: "toast-top-right",
              }
            );
          } else {
            this.initForm();
            this.terms = false;
            this.toasterService.success(res?.msg, "Success", {
              positionClass: "toast-top-right",
            });
            if (status == "Ok") {
              this.displayMailSent = true;
            }
          }
          this.loading = false;
        },
        (err) => {
          console.log("Some error occured");
          this.toasterService.error(
            err?.errors[0]?.message
              ? err?.errors[0]?.message
              : "Some error occured",
            "Error",
            {
              positionClass: "toast-top-right",
            }
          );
          this.loading = false;
        }
      );
    } else {
      this.registerForm.markAllAsTouched();
      this.toasterService.warning(
        "Please fill all the required fields!",
        "Warning",
        {
          positionClass: "toast-top-right",
        }
      );
    }
  }
}
